// #MODULE - Global and singleton object to hold common app properties
// > Author: Rafael Rocha
// >
// > Create Date: <May 12, 2014>
// >
// ##DESCRIPTION: Hold common app properties
{
  const self = {};
  const map = {};

  self.CM_PAGE_ID = 'CM_PAGE_ID';

  self.currentFacetHeight = 42;

  self.setValue = function (key, value) {
    const keyParts = key.split('.');
    let keyPart;
    let localMap = map;
    let i;

    for (i = 0; i < keyParts.length; i++) {
      keyPart = keyParts[i];
      if (i === keyParts.length - 1) {
        localMap[keyPart] = value;
      } else {
        localMap[keyPart] = localMap[keyPart] || {};
        localMap = localMap[keyPart];
      }
    }
  };

  self.getValue = function (key) {
    const keyParts = key.split('.');
    let returnValue = map;
    let i;

    for (i = 0; i < keyParts.length; i++) {
      if (!returnValue) {
        // if x is null, x.y should return undefined
        returnValue = undefined;
        break;
      }
      returnValue = returnValue[keyParts[i]];
    }

    return returnValue;
  };

  module.exports = self;
}



// WEBPACK FOOTER //
// ../util/globals/index.js